import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "messageText" };
const _hoisted_2 = ["onClick"];
import MessageModal from '@/components/message/MessageModal.vue';
import useMessage from '@/composables/message/useMessage';
import useSuperAdminUser from '@/composables/useSuperAdminUser';
import { formatDateTimeWithoutSeconds } from '@/utils/utils';
import { onMounted, ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Index',
    setup(__props) {
        const { messages, criteria, totalCount, searchMessages } = useMessage();
        const { superAdminUser, fetchSuperAdminUser } = useSuperAdminUser();
        const showMessageModal = ref(false);
        const fromUserId = ref(0);
        const toUserId = ref(0);
        onMounted(() => {
            searchMessages();
            fetchSuperAdminUser();
        });
        const initMessageModal = (_fromUserId, _toUserId) => {
            if (_fromUserId == superAdminUser.value?.id) {
                fromUserId.value = 0;
                toUserId.value = _toUserId;
            }
            else if (_toUserId == superAdminUser.value?.id) {
                fromUserId.value = 0;
                toUserId.value = _fromUserId;
            }
            else {
                fromUserId.value = _fromUserId;
                toUserId.value = _toUserId;
            }
            showMessageModal.value = true;
        };
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_pagination = _resolveComponent("v-pagination");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_table = _resolveComponent("v-table");
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createBlock(_component_v_container, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                    _createElementVNode("h2", null, "メッセージ一覧", -1)
                                ])),
                                _: 1,
                                __: [11]
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                                modelValue: _unref(criteria).companyName,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(criteria).companyName) = $event)),
                                label: "企業名"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                                modelValue: _unref(criteria).userName,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(criteria).userName) = $event)),
                                label: "ユーザー名"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                                modelValue: _unref(criteria).text,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(criteria).text) = $event)),
                                label: "メッセージ本文検索"
                            }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_radio_group, {
                                modelValue: _unref(criteria).adminFilter,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(criteria).adminFilter) = $event)),
                                inline: ""
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_radio, {
                                        label: "すべて",
                                        value: "all"
                                    }),
                                    _createVNode(_component_v_radio, {
                                        label: "運営のみ",
                                        value: "onlyAdmin"
                                    }),
                                    _createVNode(_component_v_radio, {
                                        label: "運営を除く",
                                        value: "withoutAdmin"
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_radio_group, {
                                modelValue: _unref(criteria).read,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(criteria).read) = $event)),
                                inline: ""
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_radio, {
                                        label: "すべて",
                                        value: "all"
                                    }),
                                    _createVNode(_component_v_radio, {
                                        label: "未読",
                                        value: "unread"
                                    }),
                                    _createVNode(_component_v_radio, {
                                        label: "既読",
                                        value: "read"
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_btn, {
                                onClick: _cache[5] || (_cache[5] = ($event) => (_unref(searchMessages)()))
                            }, {
                                default: _withCtx(() => _cache[12] || (_cache[12] = [
                                    _createTextVNode("検索")
                                ])),
                                _: 1,
                                __: [12]
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_pagination, {
                                        modelValue: _unref(criteria).page,
                                        "onUpdate:modelValue": [
                                            _cache[6] || (_cache[6] = ($event) => ((_unref(criteria).page) = $event)),
                                            _cache[7] || (_cache[7] = ($event) => (_unref(searchMessages)()))
                                        ],
                                        length: Math.ceil(_unref(totalCount) / _unref(criteria).pageSize)
                                    }, null, 8, ["modelValue", "length"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_table, null, {
                                        default: _withCtx(() => [
                                            _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("td", null, "ID"),
                                                    _createElementVNode("td", null, "送信者"),
                                                    _createElementVNode("td", null, "受信者"),
                                                    _createElementVNode("td", null, "既読"),
                                                    _createElementVNode("td", null, "送信日時"),
                                                    _createElementVNode("td", null, "メッセージ"),
                                                    _createElementVNode("td", null, "スレッド")
                                                ])
                                            ], -1)),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (message) => {
                                                    return (_openBlock(), _createElementBlock("tr", null, [
                                                        _createElementVNode("td", null, _toDisplayString(message.id), 1),
                                                        _createElementVNode("td", null, [
                                                            _createTextVNode(_toDisplayString(message.fromUserBelongsTo), 1),
                                                            _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                                                            _createTextVNode(_toDisplayString(message.fromUserName), 1)
                                                        ]),
                                                        _createElementVNode("td", null, [
                                                            _createTextVNode(_toDisplayString(message.toUserBelongsTo), 1),
                                                            _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                                                            _createTextVNode(_toDisplayString(message.toUserName), 1)
                                                        ]),
                                                        _createElementVNode("td", null, _toDisplayString(message.read ? '既読' : '未読'), 1),
                                                        _createElementVNode("td", null, _toDisplayString(_unref(formatDateTimeWithoutSeconds)(message.sentTime)), 1),
                                                        _createElementVNode("td", null, [
                                                            _createElementVNode("p", _hoisted_1, _toDisplayString(message.text), 1)
                                                        ]),
                                                        _createElementVNode("td", null, [
                                                            _createElementVNode("span", {
                                                                onClick: ($event) => (initMessageModal(message.fromUserId, message.toUserId))
                                                            }, [
                                                                _createVNode(_component_v_icon, null, {
                                                                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                                        _createTextVNode("mdi-list-box-outline")
                                                                    ])),
                                                                    _: 1,
                                                                    __: [15]
                                                                })
                                                            ], 8, _hoisted_2)
                                                        ])
                                                    ]));
                                                }), 256))
                                            ])
                                        ]),
                                        _: 1,
                                        __: [16]
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_pagination, {
                                        modelValue: _unref(criteria).page,
                                        "onUpdate:modelValue": [
                                            _cache[8] || (_cache[8] = ($event) => ((_unref(criteria).page) = $event)),
                                            _cache[9] || (_cache[9] = ($event) => (_unref(searchMessages)()))
                                        ],
                                        length: Math.ceil(_unref(totalCount) / _unref(criteria).pageSize)
                                    }, null, 8, ["modelValue", "length"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    (showMessageModal.value)
                        ? (_openBlock(), _createBlock(MessageModal, {
                            key: 0,
                            "from-user-id": fromUserId.value,
                            "to-user-id": toUserId.value,
                            onClose: _cache[10] || (_cache[10] = ($event) => (showMessageModal.value = false))
                        }, null, 8, ["from-user-id", "to-user-id"]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
